<template>
  <a-card  class="card-class"  >
    <a-button type="primary" @click="loadData()">刷新</a-button>
    <a-table
      ref="table"
      size="middle"
      bordered
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
      :loading="loading"
      :scroll="{x:true}"
    >
      <template slot="hrefToUrl" slot-scope="text">
              <a @click="jumpToPage(text)">{{text}}</a>
            </template>
      <template slot="izActivity" slot-scope="text">
        <span v-if="text === 1" class="green">启用</span>
        <span v-if="text === 0" class="red">禁用</span>
      </template>
      <a-popconfirm
        title="确定删除吗?"
        @confirm="() => handleDelete(record)"
        slot="action"
        slot-scope="text, record"
      >
        <a>删除</a>
      </a-popconfirm>
    </a-table>
  </a-card>
</template>

<script>
import {getAppListByServiceId,getAppListByServerId} from '@/api/api'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { deleteByServiceAppId,deleteByServerAppId } from '@/api/api.js'
export default {
  mixins: [JeecgListMixin],
  props: {
    serviceId: {
      type: String,
      default: '',
    },
    serverId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dataSource: [],
      loading:false,
      /* 分页参数 */
        ipagination: {
          current: 1,
          pageSize: 999,
        },
        /* 排序参数 */
        isorter: {
          column: 'sort',
          order: 'asc',
        },
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'应用名称',
            align:"center",
            dataIndex: 'name'
          },
          {
            title:'负责人工号',
            align:"center",
            dataIndex: 'manager_dictText'
          },
          {
            title:'流水线部署地址',
            align:"center",
            dataIndex: 'deploytoolUrl',
            scopedSlots: { customRender: 'hrefToUrl' }
          },
          {
            title:'代码仓库地址',
            align:"center",
            dataIndex: 'codeUrl'
          },
          {
            title:'排序',
            align:"center",
            dataIndex: 'sort'
          },
          {
            title:'备注',
            align:"center",
            dataIndex: 'remarks'
          },
          {
            title:'是否启用',
            align:"center",
            dataIndex: 'izActivity',
            scopedSlots: {customRender: 'izActivity'}
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' }
          }
        ],
    }
  },
  methods: {
    loadData() {
      this.loading = true
      this.dataSource = []
      var params = this.getQueryParams()
      // 服务id获取应用列表
      if(this.serviceId){
        params.serviceId=this.serviceId
      getAppListByServiceId(params).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records
        } else {
          this.$message.warning(res.message)
        }
      }).finally(()=>{
        this.loading = false
      })
      // 服务器id获取应用列表
      }else if(this.serverId){
        params.serverId=this.serverId
      getAppListByServerId(params).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records
        } else {
          this.$message.warning(res.message)
        }
      }).finally(()=>{
        this.loading = false
      })
      }
      
    },
    handleDelete(record){
      // 删除服务和应用的关系
      if(this.serviceId){
        deleteByServiceAppId({serviceId:this.serviceId,appId:record.id}).then((res) => {
        if (res.success) {
          this.$message.success("删除成功")
          this.loadData();
        } else {
          this.$message.warning(res.message)
        }
      })
      .finally(() => {
        this.loading = false
      })
      // 删除服务器和应用关系
      }else if(this.serverId){
        deleteByServerAppId({serverId:this.serverId,appId:record.id}).then((res) => {
        if (res.success) {
          this.$message.success("删除成功")
          this.loadData();
        } else {
          this.$message.warning(res.message)
        }
      })
      .finally(() => {
        this.loading = false
      })

      }
      
    }
    ,
    jumpToPage(url){
      window.open(url)
    }
  },
  watch: {
    serviceId(newValue, oldValue) {
      this.loadData()
    },
    serverId(newValue, oldValue) {
      this.loadData()
    },
  },
}
</script>

<style lang="less" scoped>
.red {
  color: red;
}
.green {
  color: green;
}
.card-class{
  min-height: 900px;
}
</style>